
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class ErnnTable extends Vue {
    //二人牛牛
    table = {
        data: [],
        column: [
            {
                key: 'black',
                title: '玩家1',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let obj = Reflect.ownKeys(strzo)
                    let str = strzo[String(obj[0])].C
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'blue',
                                    marginTop: '2px'
                                }
                            },
                            obj[0] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[0])}(查询玩家)` : bulidUid(obj[0])
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px'
                            },
                            domProps: {
                                innerHTML: str.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'black',
                title: '玩家2',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let obj = Reflect.ownKeys(strzo)
                    let str = strzo[String(obj[1])].C
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'blue',
                                    marginTop: '2px'
                                }
                            },
                            obj[1] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[1])}(查询玩家)` : bulidUid(obj[1])
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                position: 'relative',
                                height: '50px'
                            },
                            domProps: {
                                innerHTML: str.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'black',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h(
                        'span',
                        {
                            style: {
                                color: color
                            }
                        },
                        str
                    )
                }
            }
        ]
    }

    @Prop()
    listdata
}
